








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class tanleEmpty extends Vue {
  //使用示例 <tableEmpty slot="empty" v-if="!loading"></tableEmpty>
  created() {}
}
